import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { navigationobject } from 'src/interface/article';

@Component({
    selector: 'app-breadcrumb-navigation',
    templateUrl: './breadcrumb-navigation.component.html',
    styleUrls: ['./breadcrumb-navigation.component.scss']
})
export class BreadcrumbNavigationComponent {
    breadCrumbNavigation: navigationobject[]
    constructor(private router: Router) {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.updateBreadcrumb();
        });
    }
    updateBreadcrumb(): void {
        this.breadCrumbNavigation = [];
        const urlSegments = this.router.url.split('/').filter(segment => segment !== '');
        
        let url = '';

        urlSegments.forEach(segment => {
            url += `/${segment}`;
            segment = segment.charAt(0).toUpperCase() + segment.slice(1);
            this.breadCrumbNavigation.push({ identifier: segment, url: url as string });
        });

    }

    // changeIssue(issue: any) {
    //     // Regular expression pattern to match 'and'
    //     let pattern: RegExp = /\and/;

    //     // Replace 'and' with '/'
    //     let outputString: string = issue.replace(pattern, '/');
    //     return outputString;
    // }
    changeIssue(issue: any) {
        // Regular expression pattern to match 'and'
        const pattern = /and/;
        let outputString: string = 'Issue ' + issue;
        if (issue.match(pattern)) {
            // Replace 'and' with '/'
            outputString = 'Issue ' + issue.replace(pattern, ' & ');
        }

        // Regular expression pattern to match 's' followed by a number
        const nextpattern = /s(\d+)/;

        if (issue.match(nextpattern)) {
            const issue_num =issue.match(nextpattern)[1];
            // Replace 's' followed by a number with 'supplementary issue' followed by that number
            outputString = issue.replace(nextpattern, 'Supplementary issue ' + issue_num);
        }

        if(issue == 'non-issue'){
            outputString = 'Regular articles';
        }

        return outputString;
    }

    
}
